import React, { useState } from 'react';
import { useIntl } from 'react-intl';
import moment from 'moment';

export function setCashOutApprovalColumns(departmentFilter, staffStatusFilter, onFilterChange, isTooltipOpen) {
    const intl = useIntl();
    return [
        {
            name: 'id',
            label: 'ID',
            options: {
                filter: false,
                sort: true,
                display: false,
            },
        },
        {
            name: 'staffNo',
            label: intl.formatMessage({ id: 'leave_approval.staff_number' }),
            options: {
                filter: true,
                sort: true,
                filterType: 'textField',
            },
        },
        {
            name: 'employee',
            label: intl.formatMessage({ id: 'leave_approval.employee' }),
            options: {
                filter: true,
                sort: true,
                filterType: 'textField',
            },
        },
        {
            name: 'position',
            label: intl.formatMessage({ id: 'leave_approval.position' }),
            options: {
                filter: true,
                sort: true,
                filterType: 'textField',
            },
        },
        {
            name: 'location',
            label: intl.formatMessage({ id: 'leave_approval.location' }),
            options: {
                filter: true,
                sort: true,
            },
        },
        {
            name: 'department',
            label: 'Department',
            options: {
                sort: true,
                filter: true,
                filterList: departmentFilter,
            },
        },
        {
            name: 'staffDuty',
            label: intl.formatMessage({ id: 'hr_admin.staff_duty' }),
            options: {
                filter: true,
                sort: true,
            },
        },
        {
            name: 'staffStatus',
            label: intl.formatMessage({ id: 'hr_admin.staff_status' }),
            options: {
                filter: true,
                sort: true,
                filterList: staffStatusFilter,
            },
        },
        {
            name: 'from',
            label: intl.formatMessage({ id: 'common.from' }),
            options: {
                filter: false,
                sort: true,
                customHeadLabelRender: (columnMeta) => {
                    return (
                        <span
                            style={{
                                border: isTooltipOpen
                                    ? '1px solid red'
                                    : 'none',
                                borderRadius: '2px',
                                padding: isTooltipOpen ? '3px' : '0',
                            }}
                        >
                            {columnMeta.label}
                        </span>
                    );
                },
            },
        },
        {
            name: 'to',
            label: intl.formatMessage({ id: 'common.to' }),
            options: {
                filter: false,
                sort: true,
            },
        },
        {
            name: 'remaining',
            label: intl.formatMessage({ id: 'comp_leave.remaining' }),
            options: {
                filter: false,
                sort: true,
            },
        },
    ];
}
export function setCashOutApprovalOptions(
    selectItem,
    customToolbar,
    customToolbarSelect,
    rowsPerPage,
    onChangeRowsPerPage,
    onDepartmentFilterChange,
    onStaffStatusFilterChange
) {
    return {
        // filterType: 'checkbox',
        onFilterChange: (changedColumn, filterList, type) => {
            if (changedColumn === "department") {
                onDepartmentFilterChange(filterList[5]);
            }
            if (changedColumn === "staffStatus") {
                onStaffStatusFilterChange(filterList[7]);
            }
        },
        elevation: 1,
        download: false,
        print: false,
        search: false,
        rowsSelected: selectItem,
        selectableRows: 'multiple',
        customToolbar: customToolbar,
        customToolbarSelect: customToolbarSelect,
        textLabels: textLabels(),
        // rowsPerPage: rowsPerPage,
        // rowsPerPageOptions: [rowsPerPage],
        rowsPerPage: rowsPerPage,
        rowsPerPageOptions: [50, 100],
        onChangeRowsPerPage: onChangeRowsPerPage,
    };
}

export function setApprovalHistoryColumns() {
    const intl = useIntl();
    return [
        {
            name: 'id',
            label: 'ID',
            options: {
                filter: false,
                sort: true,
                display: false,
            },
        },
        {
            name: 'staffNo',
            label: intl.formatMessage({ id: 'leave_approval.staff_number' }),
            options: {
                filter: true,
                sort: true,
                filterType: 'textField',
            },
        },
        {
            name: 'employee',
            label: intl.formatMessage({ id: 'leave_approval.employee' }),
            options: {
                filter: true,
                sort: true,
                filterType: 'textField',
            },
        },
        {
            name: 'position',
            label: intl.formatMessage({ id: 'leave_approval.position' }),
            options: {
                filter: true,
                sort: true,
                filterType: 'textField',
            },
        },
        {
            name: 'location',
            label: intl.formatMessage({ id: 'leave_approval.location' }),
            options: {
                filter: true,
                sort: true,
            },
        },
        {
            name: 'department',
            label: intl.formatMessage({ id: 'leave_approval.department' }),
            options: {
                filter: true,
                sort: true,
            },
        },
        {
            name: 'staffDuty',
            label: intl.formatMessage({ id: 'hr_admin.staff_duty' }),
            options: {
                filter: true,
                sort: true,
            },
        },
        {
            name: 'staffStatus',
            label: intl.formatMessage({ id: 'hr_admin.staff_status' }),
            options: {
                filter: true,
                sort: true,
                display: false,
            },
        },
        {
            name: "from",
            label: intl.formatMessage({id: 'common.from'}),
            options: {
            filter: false,
            sort: true,
            }
        },
        {
            name: "to",
            label: intl.formatMessage({id: 'common.to'}),
            options: {
            filter: false,
            sort: true,
            }
        },
        {
            name: 'remaining',
            label: intl.formatMessage({ id: 'cash_out.cashed_out_hours' }),
            options: {
                filter: false,
                sort: true,
            },
        },
        {
            name: 'dateApproved',
            label: intl.formatMessage({ id: 'table.date_approved' }),
            options: {
                filter: false,
                sort: true,
            },
        },
    ];
}
export function setApprovalHistoryOptions() {
    return {
        elevation: 1,
        download: false,
        print: false,
        search: false,
        selectableRows: 'none',
        downloadOptions: {
            filename: 'CashOutApprovalRecord' + getCurrentDate() + '.csv',
            separator: ',',
        },
        textLabels: textLabels(),
    };
}

function textLabels() {
    const intl = useIntl();
    return {
        body: {
            noMatch: intl.formatMessage({ id: 'table.no_match' }),
            toolTip: intl.formatMessage({ id: 'table.sort' }),
            columnHeaderTooltip: (column) =>
                intl.formatMessage({ id: 'table.sort_for' }) +
                ` ${column.label}`,
        },
        pagination: {
            next: intl.formatMessage({ id: 'table.next' }),
            previous: intl.formatMessage({ id: 'table.previous' }),
            rowsPerPage: intl.formatMessage({ id: 'table.rowsPerPage' }),
            displayRows: intl.formatMessage({ id: 'table.displayRows' }),
        },
        toolbar: {
            search: intl.formatMessage({ id: 'table.search' }),
            downloadCsv: intl.formatMessage({ id: 'table.downloadCsv' }),
            print: intl.formatMessage({ id: 'table.print' }),
            viewColumns: intl.formatMessage({ id: 'table.viewColumns' }),
            filterTable: intl.formatMessage({ id: 'table.filterTable' }),
        },
        filter: {
            all: intl.formatMessage({ id: 'table.all' }),
            title: intl.formatMessage({ id: 'table.filters' }),
            reset: intl.formatMessage({ id: 'table.reset' }),
        },
        viewColumns: {
            title: intl.formatMessage({ id: 'table.show_columns' }),
            titleAria: intl.formatMessage({
                id: 'table.show_hide_table_columns',
            }),
        },
        selectedRows: {
            text: intl.formatMessage({ id: 'table.rows_selected' }),
            delete: 'Delete',
            deleteAria: 'Delete Selected Rows',
        },
    };
}
function getCurrentDate() {
    const newDate = new Date();
    return moment(newDate).format('_YYYY/MM/DD');
}
